<template>
  <div class="pagos-inscripcion">
    <div v-if="cargando" class="d-flex justify-center py-4">
      <v-progress-circular indeterminate color="primary" size="32" width="3" />
    </div>

    <div v-else-if="!pagos.length" class="empty-box">
      El estudiante no tiene pagos de inscripción registrados.
    </div>

    <template v-else>
      <v-tabs v-model="tabActiva" show-arrows dense class="pagos-tabs">
        <v-tab v-for="pago in pagos" :key="pago.id">
          Recibo N° {{ pago.nroRecibo }}
          <small class="ml-1 pago-tab-fecha">{{ formatFecha(pago.fechaPago) }}</small>
          <v-icon v-if="pago.yaUtilizado" small color="warning" class="ml-1">mdi-lock-outline</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabActiva">
        <v-tab-item v-for="pago in pagos" :key="pago.id">
          <v-alert
            v-if="pago.yaUtilizado"
            dense
            text
            type="warning"
            class="mt-3 mb-0">
            Este pago ya fue utilizado en una solicitud de nivelación aprobada. No puede volver a seleccionarse.
          </v-alert>
          <pago-inscripcion-card :pago="pago" class="mt-3">
            <template #acciones>
              <v-btn
                v-if="puedeSeleccionarPago"
                small
                depressed
                color="primary"
                :loading="seleccionando === pago.id"
                :disabled="!!seleccionando || pago.yaUtilizado"
                @click="seleccionar(pago)">
                <v-icon small left>mdi-check-circle-outline</v-icon>
                Seleccionar este pago
              </v-btn>
            </template>
          </pago-inscripcion-card>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </div>
</template>

<script>
import SolicitudCalificacionNivelacionService from '../../services/solicitud-calificacion-nivelacion.service';
import PagoInscripcionCard from './PagoInscripcionCard.vue';

export default {
  name: 'DialogPagosInscripcion',
  components: { PagoInscripcionCard },
  props: {
    inscripcionModuloId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      cargando: false,
      pagos: [],
      tabActiva: 0,
      seleccionando: null,
    };
  },
  computed: {
    puedeSeleccionarPago() {
      const idCargo = this.$store.state.CARGO?.id;
      return idCargo === 1 || idCargo === 15; // MASTER || AUXILIAR CONTABLE
    },
  },
  methods: {
    async cargar() {
      if (!this.inscripcionModuloId) return;
      this.cargando = true;
      this.pagos = [];
      try {
        const { data } = await SolicitudCalificacionNivelacionService.listarPagosInscripcion(
          this.inscripcionModuloId,
        );
        this.pagos = data?.datos || [];
        this.tabActiva = 0;
      } catch (error) {
        const mensaje = error?.response?.data?.mensaje || error.message || 'Error al obtener los pagos de inscripción';
        this.$notify({ group: 'notifications', title: 'Error', text: mensaje, type: 'error' });
      } finally {
        this.cargando = false;
      }
    },
    seleccionar(pago) {
      this.seleccionando = pago.id;
      this.$emit('seleccionado', pago);
    },
    detenerSeleccion() {
      this.seleccionando = null;
    },
    formatFecha(fecha) {
      if (!fecha) return '—';
      const [year, month, day] = `${fecha}`.slice(0, 10).split('-');
      return `${day}/${month}/${year}`;
    },
  },
};
</script>

<style scoped>
.pagos-inscripcion {
  min-height: 80px;
}

.pagos-tabs {
  border-bottom: 1px solid #dce6f0;
}

.pago-tab-fecha {
  color: #9ca3af;
}

.empty-box {
  font-size: 12px;
  color: #9ca3af;
  border: 1px dashed #dce6f0;
  border-radius: 8px;
  padding: 14px;
  text-align: center;
}
</style>
